<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t('cos.image_slim')"
             :default-cancel="false" :width="400" @close="closeDialog">
    <div>
      <ul class="form-list">
        <li class="pure-text-row">
          <div class="form-label">
            <label>
              <span>{{$t('cos.image_slim_auto_label')}}</span>
              <span class="tc-15-bubble-icon tc-15-triangle-align-start">
                <i class="tc-icon icon-what"></i>
                <span class="tc-15-bubble tc-15-bubble-top" style="display: block;">
                  <span class="tc-15-bubble-inner">{{$t('cos.image_slim_auto_tips')}}</span>
                </span>
              </span>
            </label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <qc-switch v-model="editAutoMode"></qc-switch>
            </div>
            <div v-if="editAutoMode">
              <span style="display:inline-block;margin-right:10px;">{{$t('cos.image_slim_suffix_label')}}</span>
              <label v-for="(suffix, index) in suffixList" :key="index"
                     style="display:inline-block;margin-right:10px;cursor:pointer">
                <input type="checkbox" v-model="suffixMap[suffix.value]" style="vertical-align:text-bottom;">
                <span>{{suffix.label}}</span>
              </label>
            </div>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>
              <span>{{$t('cos.image_slim_api_label')}}</span>
              <span class="tc-15-bubble-icon tc-15-triangle-align-start">
              <i class="tc-icon icon-what"></i>
              <span class="tc-15-bubble tc-15-bubble-top" style="display: block;">
                <span class="tc-15-bubble-inner" v-html="$t('cos.image_slim_api_tips_html')"></span>
              </span>
            </span>
            </label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <span v-if="allowAPIMode">
                <qc-switch v-model="editAPIMode"></qc-switch>
              </span>
              <span v-else>
                <qc-bubble type="error">
                  <span style="cursor:not-allowed">
                    <qc-switch :checked="false" disabled></qc-switch>
                  </span>
                  <template slot="popup">{{$t('cos.image_slim_api_no_need_tips')}}</template>
                </qc-bubble>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <p class="mt-10">
        <span class="text-label" v-html="$t('cos.image_slim_tips_html')"></span>
      </p>
    </div>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="onConfirm" :title="$t('core.ok')">{{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import cosExpand from '@/scripts/helper/cos/cosExpand';
import { tips } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editAutoMode: false,
      editAPIMode: false,
      suffixMap: {
        jpg: false,
        png: false,
      },
      suffixList: [
        { value: 'jpg', label: 'JPG/JPEG' },
        { value: 'png', label: 'PNG' },
        { value: 'gif', label: 'GIF' },
      ],
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
    allowAPIMode() {
      const autoFull = this.editAutoMode && this.suffixList.every(suffix => this.suffixMap[suffix.value]);
      return !autoFull;
    },
    autoOpenAndSuffixEmpty() {
      return this.editAutoMode && !this.suffixList.some(suffix => this.suffixMap[suffix.value]);
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      const imageSlim = this.bucketInfo.imageSlim || {};
      const modeArr = imageSlim?.SlimMode?.split(',') || [];
      this.editAutoMode = modeArr.includes('Auto');
      this.editAPIMode = modeArr.includes('API');
      const suffixMap = { jpg: false, png: false, gif: false };
      (imageSlim?.Suffixs?.Suffix || []).forEach(suffix => {
        suffixMap[suffix] = true;
      });
      this.suffixMap = suffixMap;
    },
    onConfirm() {
      this.submit();
    },
    submit() {
      if (this.autoOpenAndSuffixEmpty) {
        tips.error(window.lang.err('cos.image_slim_auto_open_and_suffix_empty_tips'));
        return;
      }
      const { Bucket, Region, versioning } = this.bucketInfo;
      const modeArr = [];
      if (this.editAutoMode) modeArr.push('Auto');
      if (this.editAPIMode && this.allowAPIMode) modeArr.push('API');
      const suffixList = this.suffixList.filter(item => this.suffixMap[item.value]).map(item => item.value);
      const editImageSlim = {
        SlimMode: modeArr.join(','),
        Suffixs: {
          Suffix: suffixList,
        },
      };
      cosExpand.setBucketImageSlim(Bucket, Region, versioning, editImageSlim)
        .then(() => {
          this.closeDialog();
          tips.success(window.lang.t('core.success', { msg: window.lang.t('core.setting') }));
          this.$emit('submit', { type: 'imageSlim', params: editImageSlim });
        })
        .catch(err => {
          this.closeDialog();
          const { error } = err;
          const code = err.code || error?.code || error?.Code;
          if (code === 'AccessDenied') {
            tips.error(this.$t('error.no_permissions_to_put_bucket_versioning'));
          } else {
            tips.error(window.lang.err('state.fail.versioning', err));
          }
        });
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
